/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import CommentTool from 'containers/CommentTool';
import Panel from 'panelComponents/Panel';
import CommentList from 'commentComponents/CommentList';

const CommentPanel = (props) => {

    const {memoDetail, clearWorkOrderDetail, orderId, header, detailKey} = props;
    let comments = null,
        commentsLoading = false;

    if (memoDetail) {
        comments = memoDetail.getIn(['details', 'getMemoItem']);

        

        commentsLoading = memoDetail.get('loading');
    }

    return (
        <Panel
            loading={commentsLoading}
            hasDetails
            orderId={orderId}
            detailKey={detailKey}
            clearWorkOrderDetail={clearWorkOrderDetail}
            header={header}>

            <div
                style={{
                height: '300px',
                width: '100%',
                overflowY: 'auto',
                overflowX: 'hidden'
            }}>
                <CommentList comments={comments}/>
            </div>

            <CommentTool orderId={orderId}/>

        </Panel>

    );
};

CommentPanel.propTypes = {
    memoDetail: PropTypes.object,
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    detailKey: PropTypes.string
};
export default CommentPanel;



// WEBPACK FOOTER //
// ./src/components/comment/CommentPanel.js